import { DateTime } from 'luxon';

import SessionClientDashboard from 'dashboard/lib/clients/SessionClientDashboard';
import { Period } from 'dashboard/lib/unixTime';
import { formatDateRangeEnd, formatDateRangeStart } from 'dashboard/lib/utils/formatters';
import { Environment } from 'dashboard/models/environment';
import {
  MetricsFilterParams,
  setMetricsVolumeOverTime,
} from 'dashboard/redux/actions/metrics-transaction';
import { DashboardThunkAction } from 'dashboard/redux/types';
import { ApiEndpoint } from 'lib/interfaces/api';
import { Iso8601DateString } from 'lib/types';

function getPeriod(start: Iso8601DateString, end: Iso8601DateString): Period {
  // somewhat arbitrary 4 week cutoff
  return DateTime.fromISO(end).diff(DateTime.fromISO(start), 'days').days > 28
    ? Period.Week
    : Period.Day;
}

export const loadMetricsTransactionVolumeOverTime = (
  currentEnvironment: Environment,
  filters: MetricsFilterParams,
): DashboardThunkAction => {
  return async (dispatch) => {
    const { createdAtStart, createdAtEnd, transactionTypeIds } = filters;

    const filterParams = {
      'environment-id': currentEnvironment.id,
      'txn-type-ids': transactionTypeIds,
      'created-at-start': formatDateRangeStart(createdAtStart),
      'created-at-end': formatDateRangeEnd(createdAtEnd),
      /* @ts-expect-error [strict-migration] The following line is not strict; please fix! */
      period: getPeriod(createdAtStart, createdAtEnd),
    };
    const transactionStatusOverTime = (
      await SessionClientDashboard.getResourceMetaTyped<ApiEndpoint.MetricsTransactionsVolumeOverTime>(
        ApiEndpoint.MetricsTransactionsVolumeOverTime,
        {
          filter: filterParams,
        },
      )
    ).meta;

    /* @ts-expect-error [strict-migration] The following line is not strict; please fix! */
    dispatch(setMetricsVolumeOverTime(transactionStatusOverTime, new Date().toISOString()));
  };
};
